import React, {forwardRef, useImperativeHandle, useState} from "react";
import {FormattedMessage} from "react-intl";
import {Checkbox, Form, Input, Table} from "antd";
import generateId from "../../utils/generateId";
import { Select } from 'antd';
import SubTitleInput from "./SubTitleInput";
import { Button } from 'antd';
const { Option } = Select;


const SubTitleManager = forwardRef(({subtitles= []}, ref)=> {
  const [data, setData] = useState(subtitles.map(item => ({...item, id: generateId()})))

  const updateAudio = (audio) => {
    setData(prevState => prevState.map(item => item.id === audio.id ? audio : item))
  }

  useImperativeHandle(ref, () => ({
    getSubtitles: () => data
  }));

  const setDefault = (audio) => {
    const isDefault = audio.is_default
    setData(prevState => prevState.map(item => isDefault && item.id === audio.id ? audio : ({...item, is_default: false})))
  }

  const addFile = (newSubtitle) => {
    setData(prevState => [...prevState, {...newSubtitle , id: generateId()}])
  }

  const removeFile = (id) => {
    setData(prevState => prevState.filter(item => item.id !== id))
  }

  const columns = [{
    key: "index",
    width:20,
    align:"right",
    title: <FormattedMessage id={"index"} defaultMessage={"index"}/>,
    render : (record) => record.index
  },{
    key: "path",
    width:150,
    align:"center",
    title: <FormattedMessage id={"path"} defaultMessage={"path"}/>,
    render : (record) => record.path
  },{
    key: "bit_rate",
    align:"center",
    title: <FormattedMessage id={"bit_rate"} defaultMessage={"bit_rate"}/>,
    render : (record) => record.bit_rate
  },{
    key: "profile",
    align:"center",
    title: <FormattedMessage id={"profile"} defaultMessage={"profile"}/>,
    render : (record) => record.profile
  },{
    key: "codec",
    align:"center",
    title: <FormattedMessage id={"codec"} defaultMessage={"codec"}/>,
    render : (record) => record.codec
  },{
    key: "duration",
    align:"center",
    title: <FormattedMessage id={"duration"} defaultMessage={"duration"}/>,
    render : (record) => record.duration
  },{
    key: "language",
    align:"center",
    width:120,
    title: <FormattedMessage id={"language"} defaultMessage={"language"}/>,
    render : (record) =>{
      return(
        <Select value={record.language} onChange={(value) => updateAudio({...record, language: value})}>
          <Option value="eng">English</Option>
          <Option value="per">Persian</Option>
        </Select>
      )
    }
  },{
    key: "title",
    align:"center",
    title: <FormattedMessage id={"Title"} defaultMessage={"Title"}/>,
    render : (record) => <Input value={record.title} onChange={(e) => updateAudio({...record, title: e.target.value})}/>
  },{
    key: "is_default",
    align:"center",
    title: <FormattedMessage id={"default"} defaultMessage={"default"}/>,
    render : (record) => <Checkbox checked={record.is_default} onChange={(e) => setDefault({...record, is_default: e.target.checked})}/>
  },{
    key: "actions",
    title: "",
    align:"left",
    render : (record) => <Button size={'small'} type={"danger"}  onClick={() => removeFile(record.id)}><FormattedMessage id={"delete"} defaultMessage={"delete"}/></Button>
  }]

  return(
    <div>
      <SubTitleInput addFile={addFile} subtitles={data}/>

      <Table
        bordered
        dataSource={data}
        columns={columns}
        pagination={false}
      />
    </div>
  )
})

export default SubTitleManager